import { THEME } from '../../utils/theme';

// Avatar component - displays Steam avatar or fallback
const Avatar = ({ src, name, size = 32, color, style = {} }) => {
  const initial = name ? name.charAt(0).toUpperCase() : '?';
  const bgColor = color || THEME.bgElevated;

  if (src) {
    return (
      <img
        src={src}
        alt={name}
        style={{
          width: size,
          height: size,
          borderRadius: '50%',
          objectFit: 'cover',
          border: `2px solid ${bgColor}`,
          ...style
        }}
        onError={(e) => {
          e.target.style.display = 'none';
          e.target.nextSibling.style.display = 'flex';
        }}
      />
    );
  }

  return (
    <div style={{
      width: size,
      height: size,
      borderRadius: '50%',
      background: `${bgColor}30`,
      border: `2px solid ${bgColor}`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: bgColor,
      fontSize: size * 0.4,
      fontWeight: '700',
      ...style
    }}>
      {initial}
    </div>
  );
};

export default Avatar;
